export const savedReportsViews = {
  TABLE: 'TABLE',
  GRID: 'GRID'
};
export const REPORTS_VIEW_STORAGE_KEY = 'saved-reports-view';